<template>
  <div
    class="text-smaller font-bold uppercase"
    :class="{ 'flex justify-between': isNotDesktop }"
  >
    <div class="flex flex-col">
      <div
        class="xl:mb-4"
        :class="{
          'font-roboto text-[20px] font-medium normal-case leading-6':
            isTeacherTest,
        }"
      >
        Вопрос:
        <span class="text-ruby-red-100 xl:text-[#1F1F1F]"
          >{{ question.current + 1 }} из {{ question.total }}</span
        >
      </div>
      <div
        v-if="!isNotDesktop"
        class="w-full bg-ruby-red-16"
        :class="[isTeacherTest ? 'h-1 rounded-sm' : 'h-2']"
      >
        <div
          class="h-full bg-ruby-red-100"
          :class="{ 'rounded-sm': isTeacherTest }"
          :style="'width: ' + getQuestionsProgress + '%'"
        ></div>
      </div>
    </div>
    <div v-if="totalTestTime && isNotDesktop">
      <span>Осталось: </span>
      <span class="text-ruby-red-100">{{ getTimeLeft }}</span>
    </div>
    <div v-if="totalTestTime" class="mt-14 hidden flex-col xl:flex">
      <div class="flex items-center justify-center">
        <svg
          width="200"
          height="200"
          viewBox="0 0 200 200"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            opacity="0.32"
            cx="100"
            cy="100"
            r="93"
            stroke="#D9D9D9"
            stroke-width="14"
          />
          <path
            ref="path"
            fill="none"
            stroke-width="14"
            stroke="#a4031f"
            :stroke-dasharray="getTimeLeftProgress"
            d="M100 7
           a 93 93 0 0 1 0 186
           a 93 93 0 0 1 0 -186"
          >
            <animate
              attributeName="stroke-dasharray"
              :from="[pathLength, 0]"
              :to="getTimeLeftProgress"
              dur="1s"
            />
          </path>
          <text
            x="100"
            y="100"
            fill="#a4031f"
            text-anchor="middle"
            dy="7"
            font-size="32"
          >
            {{ getTimeLeft }}
          </text>
        </svg>
      </div>
    </div>
    <BaseTheButtonNew
      v-if="!isNotDesktop && !isTeacherTest"
      class="mx-auto mt-14"
      type="secondary"
      is-small
      :text="
        testState !== 'finished'
          ? currentAnswerId > 0
            ? 'Следующий вопрос'
            : 'пропустить'
          : question.isSuccessTest
          ? 'Успех'
          : 'Попробуйте снова'
      "
      @click="handleTest()"
    />
  </div>
</template>

<script setup>
const props = defineProps({
  totalTestTime: {
    type: Number,
    default: 0,
  },

  question: {
    type: Object,
    default: () => ({}),
  },

  testState: {
    type: String,
    default: 'ready',
  },

  currentAnswerId: {
    type: Number,
    default: 0,
  },

  isTeacherTest: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits([
  'time-is-left',
  'on-miss-question-click',
  'handle-reset-test',
]);

const { isNotDesktop } = useBreakpoint();

const timer = ref(null);
const currentTime = ref(0);
const path = ref(null);
const pathLength = ref(0);

const getQuestionsProgress = computed(() => {
  return Math.floor(
    ((props.question.current + 1) / props.question.total) * 100,
  );
});

const getTimeLeft = computed(() => {
  const secondsLeft = props.totalTestTime * 60 - currentTime.value;
  const minutes = Math.floor(secondsLeft / 60);
  let seconds = secondsLeft % 60;
  if (String(seconds).length < 2) seconds = `0${seconds}`;
  return `${minutes}:${seconds}`;
});

const getTimeLeftProgress = computed(() => {
  const progressInPercentage = Math.floor(
    (currentTime.value / (props.totalTestTime * 60)) * 100,
  );
  return [
    pathLength.value * (progressInPercentage / 100),
    pathLength.value * (1 - progressInPercentage / 100),
  ];
});

watch(currentTime, () => {
  if (currentTime.value >= props.totalTestTime * 60) {
    clearInterval(timer.value);
    emit('time-is-left');
  }
});

watch(
  () => props.testState,
  () => {
    if (props.testState === 'ready') {
      currentTime.value = 0;
      clearInterval(timer.value);
      timer.value = null;
    }
    if (props.testState === 'proceed' && isNotDesktop.value) {
      startTimer();
    }
    if (props.testState === 'finished') {
      clearInterval(timer.value);
    }
  },
);

onMounted(() => {
  if (props.totalTestTime && !isNotDesktop.value) {
    startTimer();
  }
  pathLength.value = path.value?.getTotalLength();
});

onBeforeUnmount(() => {
  if (props.totalTestTime) {
    clearInterval(timer.value);
  }
});

const handleTest = () => {
  if (props.testState !== 'finished') {
    emit('on-miss-question-click');
  } else {
    emit('handle-reset-test');
  }
};

const startTimer = () => {
  if (props.totalTestTime) {
    timer.value = setInterval(() => currentTime.value++, 1000);
  }
};
</script>

<style lang="scss"></style>
